import React from 'react';
import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';
import Anchor from '../../components/Atoms/Anchor';
import Qoute from '../../components/Molecules/Quote';
import Faq from '../../components/Molecules/Faq';
import Expert from '../../components/Molecules/Expert';
import Tag from '../../components/Atoms/Tag';
import Chip from '../../components/Atoms/Chip';
import Card from '../../components/Molecules/Card';
import './style.scss';

const ComponentenTest = () => {
  return (
    <Container>
      <br />
      <div className="test_tags">
        <Tag text="Tag" icon="copy" className="dark" />
        <Tag text="Tag" icon="info" className="dark" />
        <Tag text="Tag" />
      </div>
      <br />
      <div className="test_tags">
        <Chip text="Chip" id="Chip1" />
        <Chip text="Chip" id="Chip2" disabled />
      </div>
      <br />
      <div className="test_radios">
        <div>
          <label htmlFor="radio"><div className="icon icon-check-radio icon-variant-3" /> <input type="radio" name="radio" id="radio" />Radio</label>
          <label htmlFor="radio1"><div className="icon icon-check-radio icon-variant-3" /> <input type="radio" name="radio1" id="radio1" />Radio</label>
        </div>
      </div>
      <br />
      <div className="test_buttons">
        <Button className="Button--primary">Hallo</Button>
        <Button className="Button--secondary">Hallo</Button>
        <Button className="Button--ghost">Hallo</Button>
      </div>
      <br />
      <Anchor word="psychologische mechanismen" explanation="Psychische mechanismen zijn mechanismen die zich afspelen binnen de psyche van een individuele persoon. Een beroemd voorbeeld is het mechanisme waarmee de onderwijspedagoog Johann Friedrich Herbart (1776-1841) het bewustworden van gedachten beschreef (hij sprak, meer algemeen, van “voorstellingen”)." />
      <br />
      <div className="row test_cards">
        <div className="col-12 col-md-6 col-lg-4">
          <Card title="Titel van dit artikel" body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat." image="https://img.buzzfeed.com/buzzfeed-static/static/2021-04/30/4/asset/13ec16e38007/sub-buzz-1135-1619756508-15.png" alt="" type="article" link="/" />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <Card title="Titel van deze download" body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat." type="download" link="/" />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <Card title="Titel van dit onderzoek" body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat." type="practical" link="/" />
        </div>
      </div>
      <br />
      <div className="row test_cards">
        <div className="col-12 col-md-6 col-lg-4">
          <Card small title="Titel van dit artikel" body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat." image="https://img.buzzfeed.com/buzzfeed-static/static/2021-04/30/4/asset/13ec16e38007/sub-buzz-1135-1619756508-15.png" alt="" type="article" link="/" />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <Card small title="Titel van deze download" body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat." type="download" link="/" />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <Card small title="Titel van dit onderzoek" body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat." type="practical" link="/" />
        </div>
      </div>
      <br />
      <Qoute name="Fedde Rutgers" imageSrc="https://www.uncinc.nl/sites/default/files/styles/max_860x860/public/2021-10/wesly-2.jpg?itok=XvGFtv5t" tag="CEO en oprichter" link="/" linkTitle="Optionele link" body="Ik heb tinnitus en hyperacusis doordat ik op jonge leeftijd meerdere oorontstekingen heb gehad en eigenlijk weet ik dus niet beter dan dat ik een ruis in mijn oren heb." />
      <br />
      <Faq question="Veelgestelde vraag?" answer="Antwoord" />
      <br />
      <Expert link="/" linkedIn="/" bio="Korte tekst over de expert. Korte tekst over de expert. Korte tekst over de expert. Korte tekst over de expert. Korte tekst over de expert. Korte tekst over de expert. Korte tekst over de expert. Korte tekst over de expert." name="Fedde Rutgers" email="MiekeCotterink@gmail.com" workfield="Expert" avatar="https://www.uncinc.nl/sites/default/files/styles/max_860x860/public/2021-10/wesly-2.jpg?itok=XvGFtv5t" />
      <br />
    </Container>
  );
};


export default ComponentenTest;
